export default __webpack_public_path__ + "fonts/king_version_logo.e52374305266a34a9026093c51d41988.png";